import { render, staticRenderFns } from "./ComplaintReaction.vue?vue&type=template&id=8f884e74&"
import script from "./ComplaintReaction.vue?vue&type=script&lang=js&"
export * from "./ComplaintReaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports